import React, { useEffect, useState } from "react";
import { BallsContainer, Ball } from "./MainStyled";
import { SwiperHits } from "../hits/HitsSwiper";

import useSound from "use-sound";

import hit from "../../../audio/hit.mp3";
import miss from "../../../audio/miss.mp3";
import lose from "../../../audio/lose.mp3";
import win from "../../../audio/win.mp3";
import select from "../../../audio/clearold.mp3";

export default function Main({
  betInfo,
  gameMode,
  isAutoOn,
  wonBalls,
  balls,
  game_settings,
  handleAbove,
  handleSelect,
  selected,
  toggleClickable,
  clickable,
  toFix,
  sound,
  volume,
}) {
  const [renderWonBalls, setrenderWonBalls] = useState([]);
  const [wonballsForHits, setwonballsForHits] = useState(0);
  const [showWin, setshowWin] = useState(false);
  const [lastBetId, setlastBetId] = useState(null);
  const [hitSFX] = useSound(hit, { volume });
  const [missSFX] = useSound(miss, { volume });
  const [winSFX] = useSound(win, { volume });
  const [loseSFX] = useSound(lose, { volume });
  const [selectSFX] = useSound(select, { volume });

  useEffect(() => {
    setrenderWonBalls([]);
  }, [gameMode]);
  useEffect(() => {
    setshowWin(false);
    if (wonBalls.length === 0) {
      setrenderWonBalls([]);
      setwonballsForHits(0);
    } else {
      if (gameMode === "sonic") {
        setrenderWonBalls(wonBalls);
        toggleClickable(true);
        setshowWin(true);
        if (lastBetId !== betInfo.betid) {
          setlastBetId(betInfo.betid);

          if (sound) {
            betInfo.winAmount > 0 ? winSFX() : loseSFX();
          }
        }
      } else {
        let allowed = 0;
        wonBalls.forEach((element, index) => {
          if (lastBetId !== betInfo.betid) {
            setlastBetId(betInfo.betid);

            setTimeout(() => {
              setrenderWonBalls((renderWonBalls) => {
                if (allowed === renderWonBalls.length) {
                  allowed += 1;
                  return [...renderWonBalls, element];
                } else {
                  return [renderWonBalls];
                }
              });
              if (allowed === index + 1) {
                if (index === wonBalls.length - 1) {
                  setTimeout(() => {
                    toggleClickable(true);
                    setshowWin(true);
                    if (sound) {
                      betInfo.winAmount > 0 ? winSFX() : loseSFX();
                    }
                  }, 300);
                }

                if (selected.includes(+element)) {
                  if (sound) hitSFX();
                  setwonballsForHits((x) => x + 1);
                } else {
                  if (sound) missSFX();
                }
              }
            }, 300 * (index + 1));
          }
        });
      }
    }
  }, [
    wonBalls,
    toggleClickable,
    gameMode,
    selected,
    sound,
    hitSFX,
    missSFX,
    betInfo.betid,
    lastBetId,
    betInfo.winAmount,
    loseSFX,

    winSFX,
  ]);
  const [unSelected, setunSelected] = useState([]);

  const unSelectFunc = (b) => {
    if (selected.includes(b)) {
      setunSelected([b]);
    } else {
      if (sound) selectSFX();
    }
    setTimeout(() => {
      setunSelected([]);
    }, 200);
  };
  return (
    <div
      style={{
        pointerEvents: clickable || isAutoOn ? "auto" : "none",
        marginTop: "20px",
        marginBottom: "4px",
      }}
    >
      <BallsContainer
        className="BallsContainer"
        mode80={gameMode === "80"}
        isAutoOn={isAutoOn}
      >
        {balls.map((ball) => (
          <Ball
            selected={selected.includes(ball) || unSelected.includes(ball)}
            unSelected={unSelected.includes(ball)}
            won={
              renderWonBalls.includes(ball.toString()) &&
              selected.includes(ball)
            }
            missed={
              renderWonBalls.includes(ball.toString()) &&
              !selected.includes(ball)
            }
            mode40={gameMode === "40"}
            modeSonic={gameMode === "sonic"}
            onClick={() => {
              handleSelect(ball);
              unSelectFunc(ball);
            }}
            key={ball}
          >
            <div />
            <span>{ball}</span>
          </Ball>
        ))}
      </BallsContainer>
      <SwiperHits
        n={selected.length}
        win={betInfo.winAmount}
        showWin={showWin}
        won={wonballsForHits}
        coeficients={game_settings}
        handleAbove={handleAbove}
        mode80={gameMode === "80"}
        mode40={gameMode === "40"}
        modeSonic={gameMode === "sonic"}
        toFix={toFix}
        sound={sound}
        volume={volume}
      />
    </div>
  );
}

// className={""}
// (selected.includes(ball) &&
//   wonBalls.includes(`${ball}`) &&
//   "both") ||
// (wonBalls.includes(`${ball}`) && "won") ||
// (selected.includes(ball) && "selected")

// if (!timer.current) {
//   timer.current = setTimeout(() => {
//     let both = document.getElementsByClassName("both");
//     let arr = [...document.getElementsByClassName("won"), ...both];
//     if (arr.length === 0) {
//       clearTimeout(timer.current);
//       timer.current = false;
//     }
//     arr.sort(() => 0.5 - Math.random());
//     for (let i = 0; i < arr.length; i++) {
//       if (arr[i].className.includes("won")) {
//         setTimeout(() => {
//           // if (sound === "1") {
//           // let miss1 = new Audio(miss);
//           // miss1.autoplay = true;
//           // }
//           arr[i].classList.add("wonAnim");
//         }, 400 + 400 * i);
//       }
//       if (arr[i].className.includes("both")) {
//         setTimeout(() => {
//           // if (sound === "1") {
//           //   let hit1 = new Audio(hit);
//           //   hit1.autoplay = true;
//           // }
//           arr[i].classList.add("bothAnim");
//         }, 400 + 400 * i);
//       }
//       setTimeout(() => {
//         if (i === arr.length - 1) {
//           toggleClickable(true);
//           clearTimeout(timer.current);
//           timer.current = false;
//         }
//       }, 400 + 400 * i);
//     }
//   }, 10);
// }
